import { useContextualBrowseEnabled } from '../hooks/useContextualBrowseEnabled'

export const BreadcrumbBarWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { enabled } = useContextualBrowseEnabled()

  if (enabled) return null

  return children
}
